export class Sms {
  receiver: string;
  message: string;
}
